export default __webpack_public_path__ + "static/media/Share.43fd475a.jpg";